module.exports = __webpack_public_path__ + "img/login_top_img.bb4d2fb4.png";